export default async function sleep(durationMillis) {
  return new Promise((resolve) => {
    setTimeout(resolve, durationMillis);
  });
}
